import axiosLib from 'axios'

function getHeaders() {
  const headers = {}
  headers.Accept = 'application/json'
  const token = localStorage.getItem('authentication')
  headers.Authorization = `Bearer ${token}`
  return headers
}

let url = import.meta.env.VITE_API_URL
if (url === '') {
  url = window.location.protocol + '//api.' + window.location.host
}

export const axios = axiosLib.create({
  baseURL: url,
  timeout: 10000,
  headers: getHeaders(),
})

let requestTimestamp = null

axios.interceptors.request.use(
  async (config) => {
    requestTimestamp = Date.now()
    /*
  if(typeof window.vue.$store.state.auth === 'undefined') {
    return Promise.resolve(config)
  }
  const c = await window.vue.$store.dispatch('auth/refreshIfNeeded').then(() => {
    requestTimestamp = Date.now()
    config.headers['Authorization'] = `Bearer ${localStorage.getItem('authentication')}`
    return Promise.resolve(config)
  })
  */
    config.headers['Calling-URL'] = window.location.href
    return config
  },
  (error) => Promise.reject(error)
)

axios.interceptors.response.use(
  (res) => {
    const responseTime = Date.now() - requestTimestamp
    if (typeof window.vue !== 'undefined') {
      window.vue.$store.dispatch('setResponseTime', responseTime)
    }
    return res
  },
  async (error) => {
    const originalRequest = error.config
    if (typeof error.response !== 'undefined') {
      if (
        error.response.status === 401 &&
        !originalRequest._retry &&
        typeof window.vue.$store.state.auth !== 'undefined'
      ) {
        if (typeof window.vue.$store.state.auth !== 'undefined') {
          window.vue.$store.dispatch('auth/setRefreshing', true)
        }
        originalRequest._retry = true // Mark the request as retried to avoid infinite loops.
        try {
          const refreshToken = localStorage.getItem('refreshToken') // Retrieve the stored refresh token.
          const url = '/auth/refresh'
          const res = await axios.post(url, { refreshToken: refreshToken })
          let canProceed = false
          if (typeof res !== 'undefined') {
            if (typeof res.data !== 'undefined') {
              if (typeof res.data.access !== 'undefined') {
                canProceed = true
                localStorage.setItem('authentication', res.data.access)
                localStorage.setItem('refreshToken', res.data.refresh)
                axios.defaults.headers.common['Authorization'] = `Bearer ${res.data.access}`
                originalRequest.headers['Authorization'] = `Bearer ${res.data.access}`
                setHeader('Authorization', `Bearer ${res.data.access}`)
                if (typeof window.vue.$store.state.auth !== 'undefined') {
                  window.vue.$store.dispatch('auth/setRefreshing', false)
                  window.vue.$store.dispatch('auth/setLoginData', res.data)
                }
                return axios(originalRequest) // Retry the original request with the new access token.
              }
            }
          }
          if (!canProceed) {
            window.location.href = '/'
            return Promise.reject(refreshError)
          }
        } catch (refreshError) {
          console.error('Token refresh failed:', refreshError)
          localStorage.clear()
          //localStorage.removeItem('authentication');
          //localStorage.removeItem('refreshToken');
          window.location.href = '/'
          return Promise.reject(refreshError)
        }
      }
    }
    if (error.code === 'ECONNABORTED') {
      return //If connection is aborted it's probably for a good reason. Logging out, or request was pending but we needed something else
    }

    if (error.code === 'ERR_NETWORK') {
      window.vue.$store.dispatch('serverStatus', 'unreacheable')
    }
    return Promise.reject(error)
  }
)

export function setHeader(key, value) {
  axios.defaults.headers[key] = value
}
